module.exports = __webpack_public_path__ + "media/images/athletes/3410-e2af8b2514b0a0d3a72d9734d27f8b05.png";